//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // 数据源
    nodeData: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    // 选项
    options: {
      default: function _default() {
        return [];
      },
      type: Array
    }
  }
};